module.exports = __webpack_public_path__ + "img/updatePass1.be1162ff.png";